export class Modelo {
    precio?: Number = 0;
    precioModelo?: number = 0;
    terreno?: string = "";
    estatus?: string = "";
    construccion?: string = "";
    imagen?: string = "";
    plantas?: string = "";
    cantidadGaleria?: number = 0;
    idModelo?: number = 0;
    idProyecto?: number = 0;
    idLanding?: Number = 0;
    idUsuarioUM?: Number = 0;
    idProspecto?: Number = 0;
    idPromocion?: number = 0;
    idEmpresaAfiliada?: Number = 0;
    nombre?: string = "";
    montoMin?: number = 0;
    montoMax?: number = 0;
    nombreProyecto?: string = "";
    cantidadVentasIndicador?: number = 0;
    montoVentasIndicador?: number = 0;
    recamaras?;
    banos?;
    estacionamientos?;
    areas?: number = 0;
    precio_min_inventario?: number = 0;
    unidades_disponibles?: number = 0;
    idsProyectos?: string = "";
    fechaInicio?: Date;
    fechaFin?: Date;
    brochure?: number = 0;
    descripcion?: string = "";
}


// Converts JSON strings to/from your types
export class Convert {
    public static toModelo(json: string): Modelo[] {
        return JSON.parse(json);
    }

    public static modeloToJson(value: Modelo[]): string {
        return JSON.stringify(value);
    }
}
